import React from "react";
import AccountAndInformationOverview from "./AccountAndInformationOverview";
import ContactInformationOverview from "./ContactInformationOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const CompanyProfile = ({ data, type }) => {
  if (!data) return <DataNotFound />;
  return (
    <React.Fragment>
      <ContactInformationOverview data={data} />
      <div className="mb-16"></div>
      <AccountAndInformationOverview data={data} type={type} />
    </React.Fragment>
  );
};
export default CompanyProfile;
